export default () => ({
  currentlyActive: null,
  setActive(id) {
    if (this.currentlyActive === id) {
        this.currentlyActive = null;
    } else {
        this.currentlyActive = id;
    }
  }
});
